export const ACTIVITY_TYPES = {
  CAPTURE_TITLE: 'capture-title',
  QUESTION_ANSWER: 'question-answer',
  QUESTION_ANSWER_PREVIEW: 'question-answer-preview',
  QUESTION_ANSWER_PHOTOS: 'question-answer-photos',
  SELECT_SINGLE: 'select-single',
  IMAGE_MULTIPLE: 'image-multiple',
  INFORMATIONAL: 'informational',
  RANKING: 'ranking',
  FINISH: 'finish',
  SHARE: 'share',
  TOP10: 'top-10',
  FORM_FIELD: 'form-field',
  BUCKET_LIST: 'bucket-list',
}

export const NON_INDEXABLE_ACTIVITY_TYPES = [
  ACTIVITY_TYPES.SHARE,
  ACTIVITY_TYPES.FINISH,
  ACTIVITY_TYPES.QUESTION_ANSWER_PHOTOS,
  ACTIVITY_TYPES.INFORMATIONAL,
  ACTIVITY_TYPES.FORM_FIELD,
  ACTIVITY_TYPES.QUESTION_ANSWER_PREVIEW,
]

export const _ = ''
